import React from "react";

import reject from "underscore/modules/reject";
import contains from "underscore/modules/contains";
import ServiceRow from "../ServiceRow";

const AvailableServices = (props) => {
  const { services, onShowModal, serviceSectionPartConfigs, orderingEnabled } = props

  if (!services) {
    return <div>Caricamento...</div>
  }

  return services
    .filter((service) => service.published === true)
    .map((service) => {
      const disabledPartConfigIds =
        service.excluded_service_section_part_config_ids || []
      const enabledServiceSectionPartConfigs = reject(
        serviceSectionPartConfigs,
        (config) => {
          return contains(disabledPartConfigIds, config.id)
        }
      )

      return (
        <ServiceRow
          key={service.id}
          service={service}
          serviceSectionPartConfigs={enabledServiceSectionPartConfigs}
          orderingEnabled={orderingEnabled}
          onShowModal={onShowModal}
        />
      )
    })
}

export default AvailableServices
